import { render, staticRenderFns } from "./SidebarItemsList.vue?vue&type=template&id=89e308b8&"
import script from "./SidebarItemsList.vue?vue&type=script&lang=js&"
export * from "./SidebarItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports